import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganisationGroupAutocompleteComponent } from './organisation-group-autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertsFromIssuesModule } from '@fleet/issue';
import { FuseAlertModule } from '@fleet/fuse';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);

    return acc;
  },
  {}
);
@NgModule({
  declarations: [OrganisationGroupAutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatIconModule,
    AlertsFromIssuesModule,
    FuseAlertModule,
    TranslocoDirective,
  ],
  exports: [OrganisationGroupAutocompleteComponent],
  providers: [
    provideTranslocoScope({
      scope: 'organisationGroupAutocomplete',
      loader: lazyTranslationloader,
    }),
  ],
})
export class OrganisationGroupAutocompleteModule {}
